import { Component, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule,JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from "jk-advcom";
import { MtrwdService, templateUrlConfigMtr } from '../_service_mtr';
import { Mtrwd } from '../_entity_mtr';
import { MilkdownMarkdownEditorComponent } from '../components/milkdown-markdown-editor/milkdown-markdown-editor.component';


@Component({
  selector: 'app-mtrwd-edit',
  templateUrl: './mtrwd-edit.component.html',
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, AdvComModule,
    MilkdownMarkdownEditorComponent,
    MaterialModule],
})

export class MtrwdEditComponent extends JkDialogEditComponent<MtrwdService,Mtrwd>{
  override srv!: MtrwdService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<MtrwdEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject,dialogRef,data);
  }
  WD014Change(newValue: string): void {
    setTimeout(async () => {
      this.srv.item = this.item;
      await this.srv.WD014Change(newValue);
      this.cloneField(this.srv.item, this.item);
      this.cdr.detectChanges();
    });
  }


  WD021Change(newValue: string): void {
    setTimeout(async () => {
      this.srv.item = this.item;
      await this.srv.WD021Change(newValue, this.ownForm);
      this.cloneField(this.srv.item, this.item);
      this.cdr.detectChanges();
    });
  }
  content(): string {
    return this.item.WD003 || '';
  }
  editContent(value: string): void {
    this.item.WD003 = value;
    //this.markEdited();
  }


}
